/** Logto-Redirect-Ziel: /tester/callback (Umsetzungsplan §5). */

import { useHandleSignInCallback } from "@logto/react"
import { useNavigate } from "react-router-dom"

export function CallbackPage() {
  const navigate = useNavigate()
  const { isLoading } = useHandleSignInCallback(() => {
    navigate("/", { replace: true })
  })

  return (
    <div className="flex h-screen items-center justify-center text-muted-foreground">
      {isLoading ? "Anmeldung wird abgeschlossen …" : null}
    </div>
  )
}
